import React from 'react';
import seo from '../../data';

export default function SocialLinks({ footer = false,dark=false }) {
	// if (seo?.social?.nav?.length === 0) return null;
	return (
		<div className='flex space-x-6 md:order-2'>
			{seo &&
				seo.social &&
				seo.social.nav.map((item) => (
					<a
						key={item.name}
						target='_blank'
						href={item.href}
						className={
							footer ? `text-gray-400 hover:text-gray-200` : dark?'text-gray-700 hover:text-gray-900':'text-white hover:text-gray-200'
						}
					>
						<span className='sr-only'>{item.name}</span>
						<item.icon
							className='h-6 w-6'
							aria-hidden='true'
						/>
					</a>
				))}
		</div>
	);
}
